import { render, staticRenderFns } from "./Selete.vue?vue&type=template&id=b0588390&scoped=true"
import script from "./Selete.vue?vue&type=script&lang=js"
export * from "./Selete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0588390",
  null
  
)

export default component.exports